import React, { useState } from "react";

import api, { handleApi } from "pages/api/api";

import DialogSelecionarMateriais from "./DialogSelecionarMateriais";

import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";

import MDBox from "components/MDBox";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";

export default function DialogCampanhaOfertaCliente({
  open,
  onClose,
  PaperComponent,
  formOfertaCliente,
  setFormOfertaCliente,
  ofertaInput,
  setOfertaInput,
  materiaisCombo,
  carregarMateriaisCombo,
  materialLabel,
  guardarOfertaCliente,
  form,
  carregarOfertasCliente,
  showAlert,
  setLoading,
}) {
  const [openSelecionarMateriais, setOpenSelecionarMateriais] = useState(false);

  const confirmarSelecionarOfertas = async (materiais) => {
    if (!form?.id) {
      showAlert("Grava primeiro o cabeçalho da campanha.", "warning");
      return;
    }

    if (!materiais || materiais.length === 0) {
      showAlert("Seleciona pelo menos um material.", "warning");
      return;
    }

    setLoading(true);

    const [_, err, meta] = await handleApi(
      api.post("Campanhas/InsCampanhaOfertasLote", {
        idcampanha: form.id,
        materiais: materiais.map((m) => ({
          refmaterialoferta: m.ref,
          qtd: Number(formOfertaCliente.qtd || 1),
          unidade: m.refmaterialunidade || formOfertaCliente.unidade || "",
          obs: formOfertaCliente.obs || "",
        })),
      })
    );

    setLoading(false);

    if (err) {
      showAlert(err, "error");
      return;
    }

    setOpenSelecionarMateriais(false);

    await carregarOfertasCliente(form.id);

    onClose();

    showAlert(meta?.message || "Ofertas inseridas.", meta?.severity || "success");
  };

  return (
    <Dialog
      PaperComponent={PaperComponent}
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          width: { xs: "calc(100% - 24px)", sm: "600px" },
          maxWidth: "100%",
          m: { xs: 1.5, md: 3 },
        },
      }}
    >
      <DialogTitle id="draggable-dialog-title" style={{ cursor: "move" }}>
        {formOfertaCliente.id ? "Editar oferta ao cliente" : "Nova oferta ao cliente"}
      </DialogTitle>

      <DialogContent
        sx={{
          px: { xs: 1.5, md: 3 },
        }}
      >
        <MDBox display="grid" gap={1.5} mt={1}>
          <div>
            <MDBox display="flex" justifyContent="space-between" alignItems="center" mb={0.5}>
              <div style={{ fontSize: 12, color: "#7b809a" }}>Material de oferta</div>

              <MDButton color="info" size="small" onClick={() => setOpenSelecionarMateriais(true)}>
                Selecionar vários
              </MDButton>
            </MDBox>

            <Autocomplete
              size="small"
              options={materiaisCombo}
              filterOptions={(x) => x}
              inputValue={ofertaInput}
              getOptionLabel={materialLabel}
              renderOption={(props, option) => (
                <li
                  {...props}
                  style={{
                    color: Number(option.inativo || 0) === 1 ? "#d32f2f" : undefined,
                    fontWeight: Number(option.inativo || 0) === 1 ? "bold" : undefined,
                  }}
                >
                  {materialLabel(option)}
                </li>
              )}
              value={
                materiaisCombo.find((m) => m.ref === formOfertaCliente.refmaterialoferta) || null
              }
              onInputChange={(_, value, reason) => {
                if (reason === "input") {
                  setOfertaInput(value);
                  setFormOfertaCliente((p) => ({ ...p, refmaterialoferta: "" }));
                  carregarMateriaisCombo(value);
                }

                if (reason === "clear") {
                  setOfertaInput("");
                  setFormOfertaCliente((p) => ({ ...p, refmaterialoferta: "" }));
                }
              }}
              onChange={(_, value) => {
                setFormOfertaCliente((p) => ({
                  ...p,
                  refmaterialoferta: value?.ref || "",
                  unidade: value?.refmaterialunidade || p.unidade,
                }));

                setOfertaInput(value ? materialLabel(value) : "");
              }}
              renderInput={(params) => <TextField {...params} placeholder="Selecione..." />}
            />
          </div>

          <MDBox display="grid" gridTemplateColumns={{ xs: "1fr", sm: "1fr 1fr" }} gap={1.5}>
            <MDInput
              label="Quantidade"
              type="number"
              value={formOfertaCliente.qtd}
              onChange={(e) => setFormOfertaCliente((p) => ({ ...p, qtd: e.target.value }))}
              fullWidth
            />

            <MDInput
              label="Unidade"
              value={formOfertaCliente.unidade}
              onChange={(e) => setFormOfertaCliente((p) => ({ ...p, unidade: e.target.value }))}
              fullWidth
            />
          </MDBox>

          <MDInput
            label="Observações"
            value={formOfertaCliente.obs}
            onChange={(e) => setFormOfertaCliente((p) => ({ ...p, obs: e.target.value }))}
            fullWidth
            multiline
            rows={3}
          />
        </MDBox>
      </DialogContent>

      <DialogActions
        sx={{
          flexWrap: "wrap",
          gap: 1,
          px: { xs: 2, md: 3 },
          pb: { xs: 2, md: 2 },
          "& .MuiButton-root": {
            width: { xs: "100%", sm: "auto" },
          },
        }}
      >
        <MDButton color="secondary" onClick={onClose}>
          Cancelar
        </MDButton>

        <MDButton color="success" onClick={guardarOfertaCliente}>
          Guardar
        </MDButton>
      </DialogActions>

      <DialogSelecionarMateriais
        open={openSelecionarMateriais}
        onClose={() => setOpenSelecionarMateriais(false)}
        materiaisCombo={materiaisCombo}
        carregarMateriaisCombo={carregarMateriaisCombo}
        materialLabel={materialLabel}
        onConfirmar={confirmarSelecionarOfertas}
      />
    </Dialog>
  );
}
